var map = {
	"./american-express.png": 515,
	"./discover.png": 516,
	"./jcb.png": 517,
	"./mastercard.png": 518,
	"./savvas-logo.jpg": 1653,
	"./visa.png": 519,
	"./wr-favicon-white.png": 520,
	"./wr-logo-white.png": 223,
	"./wr-logo.png": 521
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 692;



//////////////////
// WEBPACK FOOTER
// ./assets/images/logos .\.jpg*|.\.png*
// module id = 692
// module chunks = 0